import eReceipt from './views/e-receipt.c';

export default eReceipt;
